import api from '@/http'

const state = () => ({})

const getters = {}

const actions = {
  getInfo() {
    return new Promise((resolve, reject) => {
      api
        .get('manager/team/bank/info')
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  takeCredit(ctx, amount) {
    return new Promise((resolve, reject) => {
      api
        .post(`manager/team/bank/credit`, { amount })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  repayCredit(ctx, amount) {
    return new Promise((resolve, reject) => {
      api
        .post(`manager/team/bank/debt`, { amount })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
